import { render } from "./NewsFeatured.vue?vue&type=template&id=304003c3&scoped=true"
import script from "./NewsFeatured.vue?vue&type=script&lang=js"
export * from "./NewsFeatured.vue?vue&type=script&lang=js"

import "./NewsFeatured.vue?vue&type=style&index=0&id=304003c3&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4071947400/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304003c3"]])

export default __exports__